import React from 'react';
import {withRouter, Link} from 'react-router-dom';
import {DateTime} from 'components/UI/DateTime';
import {ShowIf} from 'components/utils';
import './_demand-info.scss';

class DemandInfo extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  render() {
    const {content, createdAt} = this.props;
    return (
      <div className="my-demand-detail">
        <div className='wrap-content-need-offer'>
          <p className='need-offer-content-black'>Nội dung:</p>
          <p className='need-offer-content'>{content}</p>
        </div>
        <div className='need-offer-content-time-wrap'>
          <span className='need-offer-content-black'>Thời gian:</span>
          <span className='need-offer-content'><DateTime dateTime={createdAt}/></span>
        </div>
        <div className='need-offer-content-category-wrap'>
          <span className='need-offer-content-black mr5'>Nhóm sản phẩm:</span>
          {
            this.props.categories.map((category, idx) => {
              return (
                <span className='category'>
                  <Link className="category-demand" to={`/list-products/${category.id}`} target="_blank">{category.name}</Link>
                  <ShowIf condition={this.props.categories.length > idx + 1}>
                    <span> / </span>
                  </ShowIf>
                </span>
              );
            })
          }
        </div>
      </div>
    );
  }
}

export default withRouter(DemandInfo);



// WEBPACK FOOTER //
// ./components/demand/DemandInfo.jsx